// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a8203bb","667":"58813326"}[chunkId] + ".chunk.js";
};